import { loadable } from 'ha/helpers/nextjs/loadable';

export { STATE_NAME } from './constants';

export const LoadableAlertbar = loadable(() => {
  return import(/* webpackChunkName: "Alertbar" */ './containers/Alertbar');
});

export { alertsReducer } from './reducer';
